import React, { useEffect } from "react";
const { SnackbarProvider } = require("notistack");

// ** Declare Notification Provider
const NotificationProvider = ({ children }: any) => {
  const providerRef = React.useRef();

  useEffect(() => {
    if (providerRef.current) {
      const notprovider: any = providerRef.current;
      const alert = (message: any, variant: any = 'success') => {
        notprovider?.enqueueSnackbar(message, {
          variant: variant,
        });
      };
      window.alert = alert as any;
    }
  }, [providerRef.current]);
  return (
    <SnackbarProvider autoHideDuration={3000} ref={providerRef as any} maxSnack={3}>
      {children}
    </SnackbarProvider>
  );
};

export default NotificationProvider;